import React, { Fragment, memo } from "react";

const Collection = ({
  children,
  path
}: {
  children?: React.ReactNode;
  path: string[]
}) => {
  return (
    <Fragment key={path.join("-")}>
      {children}
    </Fragment>
  );
}

export default memo(Collection);
